import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class ScrollNav {

  constructor(container) {
    this.container = container;
  }

  start() {
    setTimeout(() => {
      this.initNavigation();
      this.setupMenuColorScrollTrigger();
    }, 1000);
  }

  initNavigation() {
    this.header = document.getElementById('header');
    const hero = document.querySelector('.gom-hero');
    const menuSections = this.container.querySelectorAll('.light-menu, .dark-menu');
    this.colorMenuSections = hero ? [hero, ...Array.from(menuSections)] : Array.from(menuSections);
  }

  setupMenuColorScrollTrigger() {
    this.scrollTriggers = [];
    this.colorMenuSections.forEach((section) => {
      const trigger = ScrollTrigger.create({
        trigger: section,
        start: 'top 90px',
        end: 'bottom 90px',
        invalidateOnRefresh: true,
        onEnter: () => this.updateMenuColor(section),
        onEnterBack: () => this.updateMenuColor(section),
      });

      this.scrollTriggers.push(trigger);
    });
  }

  updateMenuColor(section) {
    if (this.header) {
      this.header.classList.remove('dark-menu', 'light-menu');
      if (section.classList.contains('dark-menu')) {
        this.header.classList.add('dark-menu');
      } else if (section.classList.contains('light-menu')) {
        this.header.classList.add('light-menu');
      }
    } else {
      console.error('Header element not found');
    }
  }

  resetMenuColor() {
    if (this.header) {
      this.header.classList.remove('dark-menu', 'light-menu');
    } else {
      console.error('Header element not found');
    }
  }

  dispose() {
    this.resetMenuColor();

    this.scrollTriggers.forEach((trigger) => {
      trigger.kill();
    });

    this.scrollTriggers = [];

    this.header = null;
    this.colorMenuSections = null;
    this.container = null;
  }
}
